import React from "react";
import { Button } from '@chakra-ui/react'
import { CustomButtonProps } from "../../../types/form";

export default function CustomButton({
    type = 'button',
    cta = 'primary',
    ...props
}: CustomButtonProps) {
    function renderLeftIcon(): CustomButtonProps['leftIcon'] {
        if (props.isLeftIcon) {
            return props.leftIcon
        } else {
            return undefined
        }
    }

    function renderRightIcon(): CustomButtonProps['rightIcon'] {
        if (props.isRightIcon) {
            return props.rightIcon
        } else {
            return undefined
        }
    }

    function computeButtonVariant() {
        switch(cta) {
            case 'primary':
            case 'warning':
                return 'solid'
            case 'secondary':
            case 'outline':
                return 'outline'
            case 'text':
                return 'ghost'            
            case 'link':
                return 'link'
            default:
                return 'solid'
        }
    }

    return (
        <Button
            key={props.key}
            size={props.size || "md"}
            disabled={props.disabled || false}
            width={props.width}
            type={type}
            className={props.className}
            colorScheme={props.colorScheme || (cta === 'primary' ? 'blue' : 'gray')}
            variant={computeButtonVariant()}
            isLoading={props.loading}
            loadingText='Loading'
            leftIcon={renderLeftIcon()}
            rightIcon={renderRightIcon()}
            onClick={props.onClick}
            _hover={props.hoverStyles}
        >
            {props.label}
        </Button>
    )
}